import { createApiMutationHook, type IApiMutationFunction } from "../../utils/api";

export type INotificationArchiveReadResult = {
    archived: number;
};

export const notificationArchiveReadMutation: IApiMutationFunction<void> = () => ({
    baseURL: "",
    method: "POST",
    url: "/api/notifications/archive-read",
});

// Internal Next route until the API exposes a bulk archive operation
export const useNotificationArchiveReadMutation = createApiMutationHook<void, INotificationArchiveReadResult>(
    notificationArchiveReadMutation,
);
